import {PageTitle} from "../../components/CummonComponents/PageTitle/PageTitle";
import {Publications} from "../../components/ResourcesPageComponents/Publications/Publications";
import {BlueBox} from "./styled";
import {useImageUrl, useResources} from "../../queries";
import {Loading} from "../../components/CommonComponents/Loading/Loading";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";

export const Resources = () => {
    const {data, isLoading} = useResources();
    const headerImageUrl = useImageUrl(data?.header_background);

    return (
        <>
            <Helmet>
                <title>Resources | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading/>
            ) : !data ? (
                null
            ) : (
                <>
                    <PageTitle image={headerImageUrl}>{data.header_title}</PageTitle>
                    <Publications data={data}/>
                    <BlueBox/>
                </>
            )}
        </>
    )
}
